import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DataTableDirective } from "../data-table.directive";

@Component({
	selector: "app-paginator-rows",
	standalone: false,
	templateUrl: "./paginator-rows.component.html"
})
export class PaginatorRowsComponent implements OnChanges {
	@Input() rowsOnPageSet: number[] = [];
	@Input() mfTable: DataTableDirective;
	minRowsOnPage = 0;

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["rowsOnPageSet"] && this.rowsOnPageSet?.length) {
			this.minRowsOnPage = Math.min(...this.rowsOnPageSet);
		}
	}
}